function Footer () {

    return (

        <footer className="newFooter">

            <section className="newFooter__container">

                <h4>
                    <span>DASHBOARD DE ME</span>
                    <span className="newFooter__titleSpan">CAFE</span>
                </h4>

                <p className="newFooter__description">
                    Mecafe no solo se trata de una tienda online, también llevamos nuestras analíticas para poder conocer bien cada movimiento realizado, somos perfeccionistas al máximo y eso lo demostramos con nuestro dashboard.
                </p>

                <p className="newFooter__copyright">
                    © 2025 MECAFE - Todos los derechos reservados
                </p>

            </section>

        </footer>

    )

}

export default Footer;